import { useEffect, useLayoutEffect } from "react";

/**
 * Use `useEffect` during SSR and `useLayoutEffect` in the browser to avoid warnings.
 * This will be useful when we begin to use SSR after our React 18 upgrade.
 */
const useIsomorphicLayoutEffect = typeof document !== "undefined" ? useLayoutEffect : useEffect;

export { useIsomorphicLayoutEffect };
